interface ProductWithUnit {
  name: string;
  unit?: string | null;
}

const hasUnit = (unit?: string | null) =>
  typeof unit === "string" && unit.trim().length > 0;

export const formatProductName = ({ name, unit }: ProductWithUnit) => {
  const normalizedUnit = typeof unit === "string" ? unit.trim() : "";
  return hasUnit(normalizedUnit) ? `${name} (${normalizedUnit})` : name;
};
